<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Attachment"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="newAttachment"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 150px;"
      :baseZIndex="-10"
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button
              v-for="(obj, index) in getButtons(selectedRow)"
              :key="index"
              :label="obj.label"
              :icon="obj.icon"
              class="p-button-text p-button-plain"
              @click="obj.command()"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :value="attachments"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :rowHover="true"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
      :style="{ width: '100%' }"
      :resizableColumns="true"
      columnResizeMode="expand"
    >
      <template #header>
        <div class="table-header">Related Customer Attachments</div>
      </template>

      <template #empty> No Related Attachments found! </template>
      <template #loading> Loading Related Attachments. Please wait. </template>
      <Column
        header="Actions"
        headerStyle="width: 50px; padding: 7.5px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div style="height: 26px; display: flex; align-items: center;">
            <Button
              icon="pi pi-ellipsis-h"
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <Column field="attachId" header="Id" :sortable="true">
        <template #body="slotProps">
          <div style="height: 26px; display: flex; align-items: center;">
            {{ slotProps.data.attachId ? slotProps.data.attachId : "" }}
          </div>
        </template>
      </Column>
      <Column field="fileName" header="File" :sortable="true">
        <template #body="slotProps">
          <div style="height: 26px; display: flex; align-items: center;">
            {{ slotProps.data.fileName ? slotProps.data.fileName : "" }}
          </div>
        </template>
      </Column>
      <Column field="attachDesc" header="Description" :sortable="true">
        <template #body="slotProps">
          {{
            slotProps.data.attachDesc
              ? slotProps.data.attachDesc.length > 18
                ? slotProps.data.attachDesc.substring(0, 18) + "..."
                : slotProps.data.attachDesc
              : ""
          }}
        </template>
      </Column>
      <Column header="Quote" :sortable="true">
        <template #body="slotProps">
          {{
            slotProps.data.quotation ? slotProps.data.quotation.quoteVer : ""
          }}
        </template>
      </Column>
      <Column field="dateCreated" header="Date" :sortable="true">
        <template #body="slotProps">
          <div style="height: 26px; display: flex; align-items: center;">
            {{ slotProps.data.dateCreated ? slotProps.data.dateCreated : "" }}
          </div>
        </template>
      </Column>
      <Column field="createdBy" header="Added By" :sortable="true">
        <template #body="slotProps">
          <div style="height: 26px; display: flex; align-items: center;">
            {{
              slotProps.data.createdBy ? slotProps.data.createdBy.fullName : ""
            }}
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px', overflowY: 'auto' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span
          >The current attachment maybe attached to a quotation and to a
          customer. Do you wish to delete the attachment?</span
        >
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="confirmDeleteAttachent"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Component to Create & Edit an attachments -->
    <AttachmentForm
      :attachment="attachment"
      :key="attachmentKey"
      :quotation="quotation"
      :attachmentForm="attachmentForm"
      :customer="customer"
      :hideQuotationVersionFields="true"
      @close="hideDialog"
      @saved="savedAttachment"
    />
  </div>
</template>
<script>
import CustomerService from "@/service/CustomerService";
import AttachmentService from "@/service/AttachmentService";

import AttachmentForm from "@/mbp/universalComponents/attachment/attachmentForm";
import PermissionMixin from "../../PermissionMixin.vue";

export default {
  components: {
    AttachmentForm
  },
  props: ["customer"],
  customerService: null,
  attachmentService: null,
  mixins: [PermissionMixin],
  data: () => ({
    filters: {},
    attachments: null,
    displayConfirmation: false,
    attachment: {},
    attachmentForm: false,
    FileUploads: true,
    note: {},
    file: {},
    fileLimit: 1,
    quotation: {},
    attachmentKey1: 0,
    requesting: false,
    selectedRow: null
  }),
  computed: {
    attachmentKey: {
      set(val) {
        this.attachmentKey1++;
      },
      get() {
        return "attachmentForm" + this.attachmentKey1.toString();
      }
    },
    loading() {
      if (this.attachments && this.attachments[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  created() {
    this.customerService = new CustomerService();
    this.attachmentService = new AttachmentService();
  },
  mounted() {
    this.getCustomerAttachment();
  },
  watch: {
    attachmentForm(val) {
      this.attachmentKey++;
    },
    attachment(val) {
      if (val && val.quotation) {
        this.quotation = val.quotation;
      }
    }
  },
  methods: {
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    toggleActions(event, data) {
      this.selectedRow = data;
      this.$refs.opActions.toggle(event);
    },
    getButtons(data) {
      let buttons = [
        {
          label: "Download",
          icon: "pi pi-download",
          command: () => {
            this.download(data);
          }
        }
      ];
      this.checkPermissions();
      if (this.deleteAttachment) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    hideDialog() {
      this.attachmentForm = false;
    },
    async getCustomerAttachment() {
      this.requesting = true;
      this.attachments = await this.customerService.getCustomerAttachment(
        this.$route.params.custid
      );
      this.requesting = false;
    },
    newAttachment() {
      this.file = {};
      this.attachment = {};
      this.quotation = {};
      this.attachmentForm = true;
    },
    savedAttachment({ file, attachment }) {
      this.getCustomerAttachment();

      this.attachmentForm = false;
      this.attachment = {};
    },
    openConfirmation(data) {
      this.attachment = data;
      if (data.quotation) {
        this.quotation = data.quotation;
      }
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editAttachment(data) {
      this.file = {};
      this.attachment = { ...data };
      this.updatedBy = this.$store.getters["auth/getMyProfile"];
      this.attachmentForm = true;
    },
    download(data) {
      this.checkPermissions();
      if (this.downloadAttachment === false) {
        this.$toast.add({
          severity: "error",
          summary: "Not allowed",
          detail: "You don't have permission to download the attachment",
          life: 5000
        });
        return;
      }
      this.attachmentService.fileDownloader(data.fileName);
    },
    async confirmDeleteAttachent() {
      this.closeConfirmation();

      await this.attachmentService.deleteAttachment(this.attachment.attachId);
      this.$toast.add({
        severity: "success",
        summary: "Product Collapsed",
        detail: "Activity Updated",
        life: 5000
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.clear-upload-file {
  position: absolute;
  top: 25px;
  font-size: 20px;
  right: 100px;
  color: red;
  border: none;
  background: inherit;
  cursor: pointer;
}
.relative {
  position: relative;
}
.test {
  margin-left: 10px;
}
</style>
